import { render } from "./crm-security.vue?vue&type=template&id=5e41c4e9"
import script from "./crm-security.vue?vue&type=script&lang=js"
export * from "./crm-security.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__